import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import Loading from '../Loading'
import Button from '../Button'
import NewsGame from './NewsGame'
import GameButtons from './GameButtons'

const shuffler = (array) => {
    return array.sort(() => Math.random() - 0.5)
}

/* const arrayMover = (arr, fromIndex, toIndex) => {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr
} */

const ReorderTitle = ({ news }) => {
    const [state, setState] = useState({
        isLoading: true,
        titleCorrect: news.title,
        scrambledWords: [],
        inputContent: '',
        inputContentIndexes: [],
        words: [],
        newsObject: { ...news, title: 'Título desconhecido' },
    })

    const dispatch = useDispatch()

    useEffect(() => {
        let titleWords = news.title.split(" ")

        let shuffled = shuffler(titleWords)
        let words = []
        for (let i in shuffled) {
            words.push({ word: shuffled[i], disabled: false })
        }

        const arrayTitle = state.titleCorrect.split(" ")
        const titleLength = arrayTitle.length

        const titleScrambler = (array) => {
            for (let i = 0; i < titleLength; i++) {
                function getRandomInt(max) {
                    return Math.floor(Math.random() * Math.floor(max));
                }

                let probability = getRandomInt(3)
                let j = Math.floor((Math.random() * (titleLength / 4)) + 0);

                if ((probability === 0 && i >= 2) || (probability === 0 && i <= titleLength.length - 3)) {
                    if (!arrayTitle[j].includes('span') && !arrayTitle[i].includes('span')) {
                        let tmpTagged = `<span class='scrambledLetter'>${arrayTitle[i]}</span>`
                        arrayTitle[i] = `<span class='scrambledLetter'>${arrayTitle[j]}</span>`
                        arrayTitle[j] = tmpTagged
                    }
                }
            }

            return array
        }

        const helper = (titleScrambler(arrayTitle).join(' '))

        const checkScrambledTitle = (scrambledTitle, correctTitle) => {

            const noSpanString = scrambledTitle.replace(/<\/?span[^>]*>/g, "")

            const scrambled = noSpanString.replace(/\s/g, '')
            const correct = correctTitle.replace(/\s/g, '')

            if (scrambled === correct) {
                const newHelper = (titleScrambler(arrayTitle).join(' '))

                setState({ ...state, scrambledWords: words, isLoading: false, newsObject: { ...news, title: newHelper } })
            } else {
                setState({ ...state, scrambledWords: words, isLoading: false, newsObject: { ...news, title: scrambledTitle } })
            }
        }

        checkScrambledTitle(helper, state.titleCorrect)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const cleanInput = () => {
        for (let item of state.scrambledWords) {
            if (item.disabled) {
                item.disabled = false;
            }
        }
        setState({ ...state, inputContent: '', inputContentIndexes: [] })
    }

    const handleClick = (sentWord, sentIndex) => {
        state.scrambledWords[sentIndex].disabled = true
        let updateInputContent = state.inputContent.concat(sentWord + ' ')
        let contentCheck = updateInputContent.replace(/\s/g, '')
        let titleCheck = state.titleCorrect.replace(/\s/g, '')

        if (contentCheck === titleCheck) {
            setTimeout(() => {
                dispatch(studygameActions.finishMinigame())
            }, 1000)

        } else {
            setState({ ...state, inputContent: updateInputContent, inputContentIndexes: state.inputContentIndexes.concat(sentIndex) })
        }
    }

    const deleteWord = () => {
        let length = state.inputContentIndexes.length
        let lastWordIndex = state.inputContentIndexes[length - 1]
        let lastWord = state.scrambledWords[lastWordIndex].word
        let removeFromInput = lastWord.length + 1
        state.scrambledWords[lastWordIndex].disabled = false

        // let lastIndex = state.inputContentIndexes[length - 1]
        state.inputContentIndexes.pop()
        setState({ ...state, inputContent: state.inputContent.slice(0, -removeFromInput), inputContentIndexes: length === 1 ? [] : state.inputContentIndexes })
    }

    /*     const handleCheckCorrect = () => {
            let contentCheck = state.inputContent.replace(/\s/g, '')
            let titleCheck = state.titleCorrect.replace(/\s/g, '')
     
            if (contentCheck === titleCheck) {
                dispatch(studygameActions.finishMinigame())
            } else {
                cleanInput()
            }
        } */

    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState
    const rightTitle = state.inputContent

    return (
        state.isLoading ? <Loading /> :
            <article className='white-container mb-4'>
                <NewsGame round={currentRound} news={state.newsObject} gameTitle='Reordene o título incorreto da notícia e ponha-o na ordem certa!' gameTip={<span>Dica: Somente as palavras a <span className='tip'>vermelho</span> estão fora de sítio na frase.</span>} />
                <div className='py-8 lg:py-10'>
                    <div className='flex flex-wrap lg:flex-no-wrap grid-rows-2 lg:grid-rows-1 grid-cols-1 pb-6'>
                        <div className='w-full lg:w-8/12'>
                            <input
                                disabled={true}
                                placeholder='Clique nos botões em baixo para reordenar o título completo'
                                className={`shadow border rounded w-full mb-4 py-2 px-3 my-0 ${(state.rightTitle === state.titleCorrect) ? "rightWord" : (state.rightTitle !== state.titleCorrect && rightTitle.length < state.titleCorrect.length) ? "" : 'wrongWord'}`}
                                value={state.inputContent}
                            />
                        </div>
                        <div className='w-full grid-cols-1 lg:w-4/12'>
                            <Button
                                className='sm:mb-0 mr-0 float-right'
                                disabled={!state.inputContent ? true : false}
                                onClick={cleanInput}
                            >
                                Apagar tudo
                            </Button>
                            <Button
                                className='mr-3 sm:mb-0 float-right'
                                disabled={!state.inputContent ? true : false}
                                onClick={() => !state.inputContent ? null : deleteWord()}
                            >
                                Apagar palavra
                            </Button>
                        </div>
                    </div>
                    <div className='grid gap-3 grid-cols-2 md:grid-cols-4 lg:grid-cols-6'>
                        {state.scrambledWords.map((item, index) => (
                            <Button
                                key={index}
                                disabled={item.disabled ? true : false}
                                onClick={() => handleClick(item.word, index)}
                                className='text-center justify-center py-2 mr-0 minigameButton'
                            >
                                {item.word}
                            </Button>
                        ))}
                    </div>
                </div>
                <GameButtons />
            </article >
    )
}

export default ReorderTitle